/**
 * /particuliers/aides/cee
 * ─────────────────────────────────────────────────────────────────
 * Guide éditorial complet (long-form) sur la prime énergie issue
 * du dispositif des Certificats d'Économies d'Énergie (CEE).
 *
 * Composé du composant `PrimeEnergieGuide` qui orchestre toutes les
 * sections (hero, résumé, mécanisme, familles BAR-*, bonifications,
 * conditions, démarches, cumul, positionnement SEF, FAQ, CTA).
 *
 * Le contenu factuel est centralisé dans
 * `client/src/config/cee-content.ts`.
 */

import { PrimeEnergieGuide } from '../../../../components/aides/PrimeEnergieGuide';

export default function PrimeCeePage() {
  return <PrimeEnergieGuide />;
}
